export default __webpack_public_path__ + "static/media/img3.13fe2844.png";